import { ReactComponent as ArrowLeft } from "@assets/icons/arrow_left_icon.svg";

const ArrowLeftIcon = (props: any): JSX.Element => {
  return (
    <ArrowLeft
      fill={props?.sx?.color || props?.sx?.fill}
      height={props?.sx?.height || "16px"}
      width={props?.sx?.width || props?.sx?.height || "16px"}
      {...props}
    />
  );
};

export default ArrowLeftIcon;
